import script from "./StoryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoryPage.vue?vue&type=script&setup=true&lang=ts"

import "./StoryPage.vue?vue&type=style&index=0&id=e2f407be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2f407be"]])

export default __exports__